import { media } from '@/core/hooks/useBreakpoints/useBreakpoints'
import { TTheme } from '@/core/theme'
import { ActionButton } from '@/ui/components/buttons/action'
import Typography from '@/ui/components/typography'
import { CustomTextField } from '@atbay/component-lib'
import { styled } from '@mui/system'
import ConfettiExplosion from 'react-confetti-explosion'

export const NewInvitationPageWrapper = styled('div')<{ theme?: TTheme }>`
    display: flex;
    height: 100%;
    color: ${({ theme }) => `${theme.colors.semantic.sendNewInvitationText}`};

    .invited-title {
        line-height: 36.8px;
        margin-bottom: 31px;
    }

    .error {
        position: relative;
        top: 4px;
        height: 5px;
        font-weight: 400;
        font-size: var(--font-size-xs);
        line-height: 14px;
        color: var(--color-error);
    }
`

export const Left = styled('div')<{ theme?: TTheme }>`
    flex: 1;
    padding: 31px;
    background: ${({ theme }) =>
        `${theme.colors.semantic.sendNewInvitationBackground}`};
`

export const Right = styled('div')<{ theme?: TTheme }>`
    display: flex;
    gap: 40px;
    flex: 1;
    flex-direction: column;
    align-items: center;
    ${media.sm`
        justify-content: flex-start;

        .logo{
            display:flex;
            width: 100%;
            justify-content: flex-start;
        }
    `}
    padding: 30px;
    background: ${({ theme }) =>
        `${theme.colors.semantic.sendNewInvitationBackgroundSecondary}`};

    .stance {
        color: ${({ theme }) => `${theme.colors.greys[500]}`};
        line-height: 22px;
        letter-spacing: 3px;
    }

    justify-content: center;

    .send-an-invitation {
        max-width: 400px;

        ${media.lg`
            max-width: 296px;
        `}

        a {
            margin-left: 4px;
            color: ${({ theme }) => `${theme.colors.primary[200]}`};
            cursor: pointer;
        }
    }
`

export const SignInButton = styled(Typography)<{ theme?: TTheme }>`
    color: ${({ theme }) => `${theme.colors.primary[200]}`};
    cursor: pointer;
`

export const Footer = styled('div')`
    margin-top: 50px;
`

export const StyledActionButton = styled(ActionButton)`
    margin-top: 72px;
    width: 120px;
`

export const StyledTextField = styled(CustomTextField)`
    margin-top: 20px;
`

export const StyledConfettiExplosion = styled(ConfettiExplosion)`
    position: absolute;
    top: 20%;
    right: 50%;
`

export const InviteIconWrapper = styled('div')`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90%;
`
